<template>
    <section class="home-banner-other">
      <img
        src="@/assets/images/Belfast/HeroHeader/herootherbg.png"
        class="hero-animation responsive-img hide-on-med-and-down"
      />
      <img
        src="@/assets/images/Belfast/HeroHeader/herobgmobileother.png"
        class="responsive-img hide-on-large-only show-on-medium-and-down"
      />
  <Header/>
      <div class="container">
        <div class="banner-box-other">
          <h1 v-html="title"></h1>
          <hr>
        </div>
      </div>

    </section>
</template>

<script>
 import Header from "@/components/belfast/Header";
 
export default {
  name: "other-hero-header",
  props: {
  title: String,
},
 components: {
    Header
  },
};
</script>
<style lang="scss">

</style>